module.exports = __webpack_public_path__ + "img/icon-quote.fde02b1b.svg";